"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _sidePaneActions = require("../../redux/actions/sidePaneActions");
var _FiatNavItemsComponent = _interopRequireDefault(require("./FiatNavItemsComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = {
  openRetailFiatSidePane: _sidePaneActions.openRetailFiatSidePane
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(_FiatNavItemsComponent["default"]);